const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelectorAll(".js-color-swatches-link")
            .forEach((item) =>
              item.setAttribute("href", event.currentTarget.dataset.variantLink)
            );

          const currentColor = event.currentTarget.value;

          jQuery
            .getJSON(
              `${window.Shopify.routes.root}products/${handleProduct}.js`
            )
            .done((product) => {
              const variant = product.variants.find(
                (item) =>
                  item.featured_media != null &&
                  item.options.includes(currentColor)
              );

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant.featured_media,
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );
                const mediaIndex = product.media.findIndex(
                  (media) => media.id === variant.featured_media.id
                );
                const secondaryMedia =
                  product.media[mediaIndex + 1] || product.media[0]; // Use the next media, or fallback to the first media

                const newSecondaryImage = createImageElement(
                  secondaryMedia,
                  secondaryImage ? secondaryImage.className : "media--second",
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  primaryImage
                    .animate(
                      { opacity: [1, 0] },
                      { duration: 200, easing: "ease-in", fill: "forwards" }
                    )
                    .finished.then(() => {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                    });
                }
                if (secondaryImage) {
                  if (newSecondaryImage.src !== secondaryImage.src) {
                    secondaryImage
                      .animate(
                        { opacity: [1, 0] },
                        { duration: 200, easing: "ease-in", fill: "forwards" }
                      )
                      .finished.then(() => {
                        secondaryImage.replaceWith(newSecondaryImage);
                        newSecondaryImage.animate(
                          { opacity: [0, 1] },
                          { duration: 200, easing: "ease-in" }
                        );
                      });
                  }
                } else {
                  newSecondaryImage.style.opacity = 0;
                  wrapper.appendChild(newSecondaryImage);
                  newSecondaryImage.animate(
                    { opacity: [0, 1] },
                    { duration: 200, easing: "ease-in" }
                  );
                }
              }
            })
            .fail(() => {
              console.error("Failed to fetch product data.");
            });
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}
setTimeout(function () {
  (function () {
    colorSwatches();
  })();
}, 3500);

 var productReco = setInterval(productrecoLoad, 100);
  function productrecoLoad() {
    if ($(".js-swiper-product-recommendations .swiper-wrapper").children().length > 0) {
      clearInterval(productReco);
      console.log('test area productReco........');
      colorSwatches();
      initializeSwatchesSlider();
    }
  } 
function initializeSwatchesSlider() {
 $(".swatches-slider").slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      arrows: true,
    });
    var swatchlength = $(".swatches-slider").length;
    console.log('swatchlength', swatchlength);
    $(".js-color-swatches .slick-arrow").on("click", function () {
    // var jslength = $(".js-color-swatches").length;
    $(".js-color-swatches .slick-current").trigger("click");
    console.log('trigger', this);
  });
}
$(window).on('load', function(){
  initializeSwatchesSlider()
});